export const gounsPage1=[
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kw5ag7k0/kurta/f/j/g/xxl-sg1011-sanganeri-feb-original-imag8w9xbbakjkju.jpeg?q=70",
        "brand": "Riya Creation",
        "title": "Houndstooth Rayon Blend Stitched Anarkali Gown",
        "color": "Blue",
        "selling_price": "₹466",
        "price": "₹999",
        "disscount": "53% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/9/5/7/na-s-3-4-sleeve-stitched-sho31krred-saponharsh-na-original-imagmufurbc2znpg.jpeg?q=70",
        "brand": "SAPONHARSH",
        "title": "Printed Viscose Rayon Stitched Anarkali Gown",
        "color": "Red",
        "selling_price": "₹449",
        "price": "₹1,099",
        "disscount": "59% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kzfvzww0/gown/l/z/g/16-s-short-sleeve-stitched-gown-badami-ne-style-60-original-imagbg8m9dpz4wtw.jpeg?q=70",
        "brand": "NE STYLE",
        "title": "Printed Crepe Stitched Anarkali Gown",
        "color": "Beige",
        "selling_price": "₹298",
        "price": "₹1,599",
        "disscount": "81% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kzfvzww0/gown/l/z/g/16-s-short-sleeve-stitched-gown-badami-ne-style-60-original-imagbg8m9dpz4wtw.jpeg?q=70",
        "brand": "NE STYLE",
        "title": "Printed Crepe Stitched Anarkali Gown",
        "color": "Beige",
        "selling_price": "₹298",
        "price": "₹1,599",
        "disscount": "81% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kzfvzww0/gown/n/t/z/17-xl-short-sleeve-stitched-gown-rama-green-ne-style-60-original-imagbg8mwdhswgzh.jpeg?q=70",
        "brand": "NE STYLE",
        "title": "Printed Crepe Stitched Anarkali Gown",
        "color": "Light Green",
        "selling_price": "₹284",
        "price": "₹1,599",
        "disscount": "82% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kzfvzww0/gown/v/z/l/18-l-short-sleeve-stitched-gown-nevy-blue-trikon-ne-style-60-original-imagbg8jhfhkjynd.jpeg?q=70",
        "brand": "NE STYLE",
        "title": "Printed Crepe Stitched Anarkali Gown",
        "color": "Dark Blue",
        "selling_price": "₹298",
        "price": "₹1,599",
        "disscount": "81% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/shopsy-gown/q/b/k/free-half-sleeve-semi-stitched-ss-ng-1-r4mila-original-imaggnskhergruu4.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Embroidered Net Semi Stitched Anarkali Gown",
        "color": "Pink",
        "selling_price": "₹499",
        "price": "₹2,099",
        "disscount": "76% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/8/r/g/na-xxl-sleeveless-stitched-grey-gown-m-glfashion-na-original-imagnzkhprbhezpf.jpeg?q=70",
        "brand": "GLFashion",
        "title": "Solid Rayon Blend Stitched Anarkali Gown",
        "color": "Grey",
        "selling_price": "₹689",
        "price": "₹1,199",
        "disscount": "42% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/shopsy-gown/k/j/p/free-half-sleeve-semi-stitched-ngb-09-life-sky-original-imag5gtdzhh8g7bn.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Embroidered Net Semi Stitched Anarkali Gown",
        "color": "Pink",
        "selling_price": "₹499",
        "price": "₹3,099",
        "disscount": "83% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/shopsy-gown/m/3/t/free-half-sleeve-semi-stitched-ss-ng-1-r4mila-original-imaggnssrjhz78eh.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Embroidered Net Semi Stitched Anarkali Gown",
        "color": "Pink",
        "selling_price": "₹499",
        "price": "₹2,099",
        "disscount": "76% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/3/g/z/na-m-full-sleeve-semi-stitched-rayon-gown-sky-007-glfashion-na-original-imagp5zczfbuskty.jpeg?q=70",
        "brand": "GLFashion",
        "title": "Solid Rayon Blend Semi Stitched Anarkali Gown",
        "color": "Light Blue",
        "selling_price": "₹555",
        "price": "₹999",
        "disscount": "44% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/a/l/e/na-xl-3-4-sleeve-stitched-handwork-gown-m-006-glfashion-na-original-imagnnyy4a5cqefg.jpeg?q=70",
        "brand": "GLFashion",
        "title": "Solid Rayon Blend Stitched Anarkali Gown",
        "color": "Maroon",
        "selling_price": "₹769",
        "price": "₹1,199",
        "disscount": "35% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kzu6efk0/kurta/t/w/a/xl-153-annsh-apparel-original-imagbrakqebujmzc.jpeg?q=70",
        "brand": "Annsh Apparel",
        "title": "Printed Rayon Blend Stitched Anarkali Gown",
        "color": "Yellow",
        "selling_price": "₹444",
        "price": "₹2,599",
        "disscount": "82% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kzfvzww0/gown/l/z/g/16-s-short-sleeve-stitched-gown-badami-ne-style-60-original-imagbg8m9dpz4wtw.jpeg?q=70",
        "brand": "NE STYLE",
        "title": "Printed Crepe Stitched Anarkali Gown",
        "color": "Beige",
        "selling_price": "₹298",
        "price": "₹1,599",
        "disscount": "81% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/shopsy-gown/k/v/f/free-half-sleeve-semi-stitched-ngb-01-life-sky-original-imag4kgzw2zykps2.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Net Semi Stitched Anarkali Gown",
        "color": "Grey",
        "selling_price": "₹499",
        "price": "₹3,099",
        "disscount": "83% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kzfvzww0/gown/l/z/g/16-s-short-sleeve-stitched-gown-badami-ne-style-60-original-imagbg8m9dpz4wtw.jpeg?q=70",
        "brand": "NE STYLE",
        "title": "Printed Crepe Stitched Anarkali Gown",
        "color": "Beige",
        "selling_price": "₹298",
        "price": "₹1,599",
        "disscount": "81% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/d/r/g/na-m-3-4-sleeve-stitched-handwork-gown-m-glfashion-na-original-imaghug3qckfyd54.jpeg?q=70",
        "brand": "GLFashion",
        "title": "Solid Rayon Blend Stitched Anarkali Gown",
        "color": "Multicolor",
        "selling_price": "₹779",
        "price": "₹1,199",
        "disscount": "35% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/i/n/o/na-xl-short-sleeve-stitched-gown-grey-m-glfashion-na-original-imagnzkbbs4jjqn2.jpeg?q=70",
        "brand": "GLFashion",
        "title": "Solid Rayon Blend Stitched Anarkali Gown",
        "color": "Grey",
        "selling_price": "₹679",
        "price": "₹1,199",
        "disscount": "43% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/i/a/q/na-xl-full-sleeve-stitched-re-40-raiyani-enterprise-na-original-imagc5mtp4acxzat.jpeg?q=70",
        "brand": "Femvy",
        "title": "Dyed Georgette Stitched Anarkali Gown",
        "color": "Black",
        "selling_price": "₹499",
        "price": "₹1,599",
        "disscount": "68% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kybvo280/gown/f/j/g/na-free-half-sleeve-semi-stitched-bolly-peach-zinariya-fab-na-original-imagah9kxkz4ghf8.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Embroidered Net Semi Stitched Anarkali Gown",
        "color": "Maroon",
        "selling_price": "₹499",
        "price": "₹3,099",
        "disscount": "83% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/g/g/2/na-l-3-4-sleeve-stitched-ajarak-print-sanwalisakhi-na-original-imagztpypfhhxu6h.jpeg?q=70",
        "brand": "Sanwalisakhi",
        "title": "Pure Cotton Stitched Flared/A-line Gown",
        "color": "Multicolor",
        "selling_price": "₹636",
        "price": "₹1,999",
        "disscount": "68% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/o/2/v/na-m-full-sleeve-stitched-st-224-yellow-01-black-scissor-na-original-imagn8pfwgr4kk9z.jpeg?q=70",
        "brand": "BLACK SCISSOR",
        "title": "Geometric Print Georgette Stitched Flared/A-line Gown",
        "color": "Yellow",
        "selling_price": "₹749",
        "price": "₹2,499",
        "disscount": "70% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kxdl3m80/gown/o/t/k/na-free-full-sleeve-semi-stitched-shamita-1-zinariya-fab-na-original-imag9uhekfeefghn.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Net Semi Stitched Anarkali Gown",
        "color": "Purple",
        "selling_price": "₹674",
        "price": "₹3,099",
        "disscount": "78% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kxdl3m80/gown/d/i/3/na-free-full-sleeve-semi-stitched-shamita-1-zinariya-fab-na-original-imag9uh7f2pexdmu.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Net Semi Stitched Anarkali Gown",
        "color": "Green",
        "selling_price": "₹674",
        "price": "₹3,099",
        "disscount": "78% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kzfvzww0/gown/n/t/z/17-xl-short-sleeve-stitched-gown-rama-green-ne-style-60-original-imagbg8mwdhswgzh.jpeg?q=70",
        "brand": "NE STYLE",
        "title": "Printed Crepe Stitched Anarkali Gown",
        "color": "Light Green",
        "selling_price": "₹297",
        "price": "₹1,599",
        "disscount": "81% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kzfvzww0/gown/n/t/z/17-xl-short-sleeve-stitched-gown-rama-green-ne-style-60-original-imagbg8mwdhswgzh.jpeg?q=70",
        "brand": "NE STYLE",
        "title": "Printed Crepe Stitched Anarkali Gown",
        "color": "Light Green",
        "selling_price": "₹300",
        "price": "₹1,599",
        "disscount": "81% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/m/y/f/na-free-half-sleeve-semi-stitched-bolly-peach-zinariya-fab-na-original-imag4pv9fh8n7aup-bb.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Net Semi Stitched Anarkali Gown",
        "color": "Yellow",
        "selling_price": "₹499",
        "price": "₹3,099",
        "disscount": "83% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/i/0/w/na-m-short-sleeve-stitched-gown-femvy-na-original-imag3hyesubkhaxw.jpeg?q=70",
        "brand": "Femvy",
        "title": "Solid Georgette Stitched Flared/A-line Gown",
        "color": "Blue",
        "selling_price": "₹499",
        "price": "₹1,999",
        "disscount": "75% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kpcy5jk0/gown/s/6/a/na-m-short-sleeve-stitched-ss-04-jash-creation-na-original-imag3hye6t6jykyf.jpeg?q=70",
        "brand": "Femvy",
        "title": "Solid Georgette Stitched Flared/A-line Gown",
        "color": "Black",
        "selling_price": "₹499",
        "price": "₹1,999",
        "disscount": "75% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/j/t/t/na-l-3-4-sleeve-stitched-rite1052-ftdiva-na-original-imafwphybsq4x9pg.jpeg?q=70",
        "brand": "ftDiva",
        "title": "Paisley Rayon Blend Stitched Anarkali Gown",
        "color": "Pink",
        "selling_price": "₹649",
        "price": "₹2,999",
        "disscount": "78% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/6/j/l/na-free-half-sleeve-semi-stitched-bolly-07-zinariya-fab-na-original-imag45ykcssh6sqw-bb.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Embroidered Net Semi Stitched Anarkali Gown",
        "color": "Grey",
        "selling_price": "₹680",
        "price": "₹2,999",
        "disscount": "77% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/i/0/w/na-m-short-sleeve-stitched-gown-femvy-na-original-imag3hyesubkhaxw.jpeg?q=70",
        "brand": "Femvy",
        "title": "Solid Georgette Stitched Flared/A-line Gown",
        "color": "Blue",
        "selling_price": "₹499",
        "price": "₹1,999",
        "disscount": "75% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/shopsy-gown/h/r/t/free-half-sleeve-semi-stitched-ngb-01-life-sky-original-imag3vxzhbj7rudx.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Net Semi Stitched Anarkali Gown",
        "color": "Green",
        "selling_price": "₹499",
        "price": "₹3,099",
        "disscount": "83% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/f/o/s/na-xl-3-4-sleeve-stitched-ss-40-femvy-na-original-imaggsg6dgyk3hgw.jpeg?q=70",
        "brand": "Femvy",
        "title": "Dyed Georgette Stitched Anarkali Gown",
        "color": "Red",
        "selling_price": "₹499",
        "price": "₹1,599",
        "disscount": "68% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/k4u7i4w0/gown/y/e/x/na-free-a-1-jeelraj-na-original-imaepspfjvnt3gme.jpeg?q=70",
        "brand": "Smart Shop",
        "title": "Embroidered Net Semi Stitched Anarkali Gown",
        "color": "White",
        "selling_price": "₹499",
        "price": "₹1,999",
        "disscount": "75% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/gown/b/a/d/n-a-s-3-4-sleeve-stitched-r81-ftdiva-n-a-original-imagg2znwfwudqkc.jpeg?q=70",
        "brand": "ftDiva",
        "title": "Floral Print Rayon Blend Stitched Anarkali Gown",
        "color": "Pink",
        "selling_price": "₹749",
        "price": "₹2,999",
        "disscount": "75% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/kqidx8w0/gown/m/r/j/n-a-xxl-3-4-sleeve-stitched-r88-ftdiva-n-a-original-imag4g39jmnzb7qw.jpeg?q=70",
        "brand": "ftDiva",
        "title": "Printed Rayon Blend Stitched Anarkali Gown",
        "color": "Blue",
        "selling_price": "₹729",
        "price": "₹2,999",
        "disscount": "75% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/shopsy-gown/j/c/y/free-half-sleeve-semi-stitched-ss-ng-1-r4mila-original-imaggp3bzzwtzshc.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Embroidered Net Semi Stitched Anarkali Gown",
        "color": "Purple",
        "selling_price": "₹499",
        "price": "₹2,099",
        "disscount": "76% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/shopsy-gown/w/0/q/free-half-sleeve-semi-stitched-ngb-01-life-sky-original-imag4pv7rbb2cgzb.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Net Semi Stitched Anarkali Gown",
        "color": "Green",
        "selling_price": "₹499",
        "price": "₹3,099",
        "disscount": "83% off",
        "size": ""
    },
    {
        "image": "https://rukminim1.flixcart.com/image/612/612/xif0q/shopsy-gown/h/o/4/free-half-sleeve-semi-stitched-ngb-01-life-sky-original-imag7vdaybd4qazn.jpeg?q=70",
        "brand": "Zinariya Fab",
        "title": "Embroidered Net Semi Stitched Anarkali Gown",
        "color": "Red",
        "selling_price": "₹499",
        "price": "₹3,099",
        "disscount": "83% off",
        "size": ""
    }
]